import React, { useRef, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import Common_Back_Btn from "../../../common/common_components/common_back_btn/Common_Back_Btn";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Profile_Offcanvas.css";
import Blue_Btn from "../../../common/common_btn/blue_btn/Blue_Btn";
import Basic_Info_Offcan from "./basic_info_offcan/Basic_Info_Offcan";
import Account_Setting_Offcan from "./account_setting_offcan/Account_Setting_Offcan";
import Organisation_Offcan from "./organisation_offcan/Organisation_Offcan";
import { useNavigate } from "react-router-dom";

const Profile_Offcanvas = ({ show, handleClose }) => {
  const navigate = useNavigate();
  const [showBasicInfo, setShowBasicInfo] = useState(false);
  const [showAccSetting, setShowAccSetting] = useState(false);
  const [showOrg, setShowOrg] = useState(false);

  return (
    <>
      <Offcanvas
        className="mobile_offcanvas common_offcanvas Profile_Offcanvas"
        show={show}
        placement="end"
        onHide={handleClose}
        scroll={false}
        backdrop={true}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>
            <div className="back_div" onClick={handleClose}>
              <Common_Back_Btn />
            </div>
          </Offcanvas.Title>

          <div className="profile_top_div">
            <div className="pro_pic_div">
              <img
                src="/assets/images/header/profile/user1.png"
                className="pro_img"
              />
            </div>

            <div className="dark_bg_div">
              <p className="username">
                Hello, <b>Pratiksha</b>
              </p>
              <div className="inner_div">
                <p className="inner_text">
                  <img
                    src="/assets/images/other/project-manager.png"
                    className="inner_img"
                  />
                  Designation / Role: <strong>Lab In Charge</strong>
                </p>
                <p className="inner_text">
                  <img
                    src="/assets/images/other/id.png"
                    className="inner_img"
                  />
                  User ID: <b>EMP 100029</b>
                </p>
              </div>
            </div>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="body_div">
            <div className="all_tabs_holder">
              <div
                className="tab_holder"
                onClick={() => {
                  handleClose();
                  setShowBasicInfo(true);
                }}
              >
                <div className="left_side">
                  <div className="inner_img_holder">
                    <img
                      src="/assets/images/header/profile/img1.png"
                      className="inner_img"
                    />
                  </div>
                  <p className="label_text">Basic Information</p>
                </div>

                <div className="box_div">
                  <FontAwesomeIcon icon={faAngleRight} className="arrow_icon" />
                </div>
              </div>

              <div
                className="tab_holder"
                onClick={() => {
                  handleClose();
                  setShowAccSetting(true);
                }}
              >
                <div className="left_side">
                  <div className="inner_img_holder">
                    <img
                      src="/assets/images/header/profile/img2.png"
                      className="inner_img"
                    />
                  </div>
                  <p className="label_text">Account Settings</p>
                </div>

                <div className="box_div">
                  <FontAwesomeIcon icon={faAngleRight} className="arrow_icon" />
                </div>
              </div>

              <div
                className="tab_holder"
                onClick={() => {
                  handleClose();
                  setShowOrg(true);
                }}
              >
                <div className="left_side">
                  <div className="inner_img_holder">
                    <img
                      src="/assets/images/header/profile/img3.png"
                      className="inner_img"
                    />
                  </div>
                  <p className="label_text">Organization Details</p>
                </div>

                <div className="box_div">
                  <FontAwesomeIcon icon={faAngleRight} className="arrow_icon" />
                </div>
              </div>

              {/* <div className="tab_holder">
                <div className="left_side">
                  <div className="inner_img_holder">
                    <img
                      src="/assets/images/header/profile/img4.png"
                      className="inner_img"
                    />
                  </div>
                  <p className="label_text">Activity Overview</p>
                </div>

                <div className="box_div">
                  <FontAwesomeIcon icon={faAngleRight} className="arrow_icon" />
                </div>
              </div> */}

            </div>

            <div className="offcanvas_footer">
              <p className="bold_text">Logout confirmation: </p>
              <p className="simple_text">
                Are you sure you want to exit your account?
              </p>

              <div className="btn_div">
                <Blue_Btn btnText={"Logout"} onClick={() => navigate("/login")} />
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Basic_Info_Offcan
        show={showBasicInfo}
        handleClose={() => setShowBasicInfo(false)}
      />
      <Account_Setting_Offcan
        show={showAccSetting}
        handleClose={() => setShowAccSetting(false)}
      />

      <Organisation_Offcan
        show={showOrg}
        handleClose={() => setShowOrg(false)}
      />
    </>
  );
};

export default Profile_Offcanvas;
